import * as React from 'react';
import { withStyles, createStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';


const jss = (theme: Theme) => createStyles({
    container: {
        width: '100%',
    },
    videoContainer: {
        position: 'relative',
        paddingTop: '56.25%',
        maxWidth: 1000,
        margin: `0px auto ${theme.spacing.unit * 2}px`,
    },
    video: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
    },
    root: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      },
      formControl: {
        margin: theme.spacing.unit * 4,
      },
});

interface Props {
    id: number;
    question: Bee.Question;
    selectedAnswer: string;
    handleAnswerSelect: (id: number, answer: string) => void;
    classes: {
        container: string;
        videoContainer: string;
        video: string;
        root: string;
        formControl: string;
    }
}

interface State {
    value: string | undefined;
}

class QuizQuestion extends React.Component<Props, State> {
    private formatLink = (link: string): string => {
        // /watch?v=EuHf4paBthc
        // to
        // /embed/EuHf4paBthc
        const split = link.split('watch?v=');
        const formatted = split.join('embed/');
        return formatted;
    };

    private isUrl = (str: string) => {
        // tslint:disable-next-line
        const regexp =  /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/
        if (regexp.test(str)) {
            return true;
        } else {
            return false;
        }
    }

  	render() {
        const { question, classes } = this.props;
        const url = this.formatLink(question.url);
        return (
            <div className={classes.container}>
                
                    {this.isUrl(url) ? 
                        <div className={classes.videoContainer}>
                        <iframe
                            className={classes.video}
                            frameBorder='0'
                            allowFullScreen
                            src={this.formatLink(question.url)}
                        />
                        </div>
                        :
                        <Typography variant="h4" align="center" color="error">Invalid video url</Typography>
                    }
                
                <div>
                    <Typography variant="h4" align="center" gutterBottom>Select your answer:</Typography>
                    <div className={classes.root}>
                        {question.options.map((q, ix) => (
                            <Button
                                key={ix}
                                color="primary"
                                variant={this.props.selectedAnswer === q ? "contained" : "text"}
                                fullWidth
                                size="large"
                                onClick={() => this.props.handleAnswerSelect(this.props.id, q)}
                                style={{ margin: '5px 0px' }}
                            >
                                {q}
                            </Button>
                        ))}
                    </div>
                </div>
            </div>
        );
	}
}

export default withStyles(jss)(QuizQuestion);



// WEBPACK FOOTER //
// ./src/components/Quiz/QuizQuestion.tsx